import { useNavigate, useLocation } from 'react-router-dom';

interface NavigationProps {
  scrolled?: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://public.readdy.ai/ai/img_res/f2ced16e-e20b-48a0-943a-0ea5078bd81a.png" 
              alt="Jerilyn Emerson Logo" 
              className="h-12 w-auto object-contain"
            />
            <span className="text-xl font-semibold text-[#1a2b4a]" style={{ fontFamily: 'Crimson Text, serif' }}>
              Jerilyn Emerson
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-[#1a2b4a] hover:text-[#2d9b9b] transition-colors duration-300 relative group whitespace-nowrap"
            >
              About
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2d9b9b] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-[#1a2b4a] hover:text-[#2d9b9b] transition-colors duration-300 relative group whitespace-nowrap"
            >
              Services
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2d9b9b] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#1a2b4a] hover:text-[#2d9b9b] transition-colors duration-300 relative group whitespace-nowrap"
            >
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2d9b9b] group-hover:w-full transition-all duration-300"></span>
            </button>
            <a
              href="https://www.linkedin.com/in/jerilyn-emerson/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full border border-[#1a2b4a]/20 text-[#1a2b4a] hover:text-[#2d9b9b] hover:border-[#2d9b9b] transition-colors duration-300 cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}